import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userInfoKeys } from "Auth/Api/Queries/useUserInfoQuery";
import {
  type CreateIdentityFromUserCommand,
  type SignInResult,
  postAuthMigrateCreateIdentity,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: SignInResult) => void;
  onError?: (error: unknown) => void;
};

/**
 * Creates a new Identity from the currently authenticated non-migrated User's data.
 * Works for users whose Party is a NaturalPerson (e.g., Hunter). Merchant/Employee users
 * need a separate flow that collects personal info (deferred).
 */
export const useCreateIdentityFromUserMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (data: CreateIdentityFromUserCommand = {}) =>
        postAuthMigrateCreateIdentity(data),
    ),
    onSuccess: (result: SignInResult) => {
      queryClient.invalidateQueries({ queryKey: userInfoKeys.all });
      onSuccess?.(result);
    },
    onError,
  });
};
